export default function NotFound() {
  return (
    <div className="p-10 text-center">
      <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
      <p className="text-gray-600">The page you’re looking for doesn't exist.</p>
    </div>
  );
}